import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import Reveal from "@/components/feature/Reveal";
import { featuredArticles } from "@/mocks/articles";

export default function FeaturedSection() {
  const [lead, ...rest] = featuredArticles;

  return (
    <section
      aria-labelledby="featured-heading"
      className="w-full border-b border-background-200 bg-background-50"
    >
      <div className="mx-auto w-full max-w-[1400px] px-4 py-14 md:px-8 md:py-16">
        <div className="flex items-center justify-between gap-4 border-b border-background-200 pb-5">
          <div className="flex items-center gap-3">
            <span className="flex h-2 w-2 rounded-full bg-primary-500" />
            <h2
              id="featured-heading"
              className="font-heading text-lg font-black text-foreground-950 md:text-xl"
            >
              本期头条
            </h2>
          </div>
          <Link
            to="/analysis"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
          >
            全部解读
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <Reveal className="mt-10">
          {lead ? <ArticleCard article={lead} variant="hero" /> : null}
        </Reveal>

        {rest.length > 0 ? (
          <div className="mt-12 grid grid-cols-1 gap-8 border-t border-background-200 pt-10 md:grid-cols-2">
            {rest.map((article, index) => (
              <Reveal key={article.id} delay={index * 80}>
                <div className="flex gap-5">
                  <div className="hidden h-28 w-40 shrink-0 overflow-hidden rounded-lg border border-background-200 sm:block">
                    <img
                      src={article.cover}
                      alt={`${article.title} - ${article.category}事件复盘配图`}
                      title={`${article.title} - 15黑料网深度解读`}
                      className="h-full w-full object-top object-cover"
                    />
                  </div>
                  <div className="min-w-0">
                    <p className="label-caps text-[11px] text-accent-700">
                      编辑重点 · {article.category}
                    </p>
                    <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950">
                      <Link
                        to={`/analysis/${article.slug}`}
                        className="transition-colors hover:text-primary-700 cursor-pointer"
                      >
                        {article.title}
                      </Link>
                    </h3>
                    <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">
                      {article.summary}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        ) : null}
      </div>
    </section>
  );
}